
//判断是否为管理员

const routes = [
  {// 账套列表
    path: '/login-sso',
    name: 'login-sso',
    component: () => import(`@/views/login-sso.vue`),
  },
  {// 账套列表
    path: '/account-info',
    name: 'account-info',
    component: () => import(`@/views/account-info/index.vue`),
  },
  {
    path: '/main',
    name: 'main',
    component: () => import(`@/views/main.vue`),
    children: [
      {
        path: '/asset-home-chart',
        name: 'asset-home-chart',
        meta: {
          title: '首页',
          showLeftMenu: true
        },
        component: () => import(`../views/home/index.vue`),
      },
      // 数据资源管理-图表首页
      {
        path: '/dept-assets-chart',
        name: 'dept-assets-chart',
        meta: {
          title: '数据资源管理',
          showLeftMenu: true
        },
        component: () => import(`../views/first-level-chart/dept-assets-chart/index.vue`),
      },
        // 数据资产登记-图表首页
        {
          path: '/asset-registration-chart',
          name: 'asset-registration-chart',
          meta: {
            title: '数据资源管理',
            showLeftMenu: true
          },
          component: () => import(`../views/first-level-chart/asset-registration-chart/index.vue`),
        },
           // 数据资产评估-图表首页
           {
            path: '/asset-data-assessment',
            name: 'asset-data-assessment',
            meta: {
              title: '数据资产评估',
              showLeftMenu: true
            },
            component: () => import(`../views/first-level-chart/asset-data-assessment/index.vue`),
          },
        // 数据资产会计核算-图表首页
        {
          path: '/asset-data-account',
          name: 'asset-data-account',
          meta: {
            title: '数据资产评估',
            showLeftMenu: true
          },
          component: () => import(`../views/first-level-chart/asset-data-account/index.vue`),
        },
           // 数据资产使用与处置-图表首页
           {
            path: '/asset-data-use',
            name: 'asset-data-use',
            meta: {
              title: '数据资产评估',
              showLeftMenu: true
            },
            component: () => import(`../views/first-level-chart/asset-data-use/index.vue`),
          },
        {
          path: '/asset-data-quality',
          name: 'asset-data-quality',
          meta: {
            title: '数据质量',
            showLeftMenu: true
          },
          component: () => import(`../views/first-level-chart/asset-data-quality/index.vue`),
        },

      // 数据资源编目-旧
      {
        path: '/dept-assets',
        name: 'dept-assets',
        meta: {
          title: '数据资源编目',
          showLeftMenu: true
        },
        component: () => import(`../views/deptAssets/index.vue`),
      },
      // 数据资源编目-旧  数据仓库页签
      {
        path: '/tab-data-warehouse',
        name: 'tab-data-warehouse',
        meta: {
          title: '数据资源采集',
          showLeftMenu: true
        },
        component: () => import(`../views/deptAssets/tab-data-warehouse.vue`),
      },
      // 数据资源编目-旧  数据资源页签
      {
        path: '/tab-data-resource',
        name: 'tab-data-resource',
        meta: {
          title: '数据资源管理',
          showLeftMenu: true
        },
        component: () => import(`../views/deptAssets/tab-data-resource.vue`),
      },
      // 数据资源编目 - 详情
      {
        path: '/assets-detail',
        name: 'assets-detail',
        meta: {
          title: '数据资源详情',
          showLeftMenu: true
        },
        component: () => import(`../views/deptAssets/dataProduct/dataDetail/index.vue`),
      },
      // 数据资源编目 - 详情
      {
        path: '/assets-edit',
        name: 'assets-edit',
        meta: {
          title: '数据资源编辑',
          showLeftMenu: true
        },
        component: () => import(`../views/deptAssets/dataProduct/dataEdit/index.vue`),
      },
      // 数据资源编目
      {
        path: '/dept-assets-new',
        name: 'dept-assets-new',
        meta: {
          title: '数据资源编目',
          showLeftMenu: true
        },
        component: () => import(`../views/dataResources/deptAssets/index.vue`),
      },
      // 数据资源盘点
      {
        path: '/resource-inventory',
        name: 'resource-inventory',
        meta: {
          title: '数据资源盘点',
          showLeftMenu: true
        },
        component: () => import(`../views/dataResources/resourceInventory/index.vue`),
      },
      // 数据资源目录
      {
        path: '/resource-directory',
        name: 'resource-directory',
        meta: {
          title: '数据资源目录',
          showLeftMenu: true
        },
        component: () => import(`../views/dataResources/resource-directory/index.vue`),
      },

      {//数据资产卡片登记 -- 卡片登记
        path: '/card-register',
        name: 'card-register',
        meta: {
          title: '卡片登记',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardDJ/index.vue`),
      },


      {//数据资产卡片登记 -- 卡片详情
        path: '/card-detail',
        name: 'card-detail',
        meta: {
          title: '卡片详情',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardDetail/index.vue`),
      },
      {//数据资产卡片登记 -- 卡片新建
        path: '/card-create',
        name: 'card-create',
        meta: {
          title: '卡片详情',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardCreate/index.vue`),
      },
      {//数据资产卡片登记 -- 资产编目配置
        path: '/card-allocation',
        name: 'card-allocation',
        meta: {
          title: '卡片详情',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardAllocation/index.vue`),
      },
      {//数据资产卡片登记 -- 外部登记
        path: '/card-outRegister',
        name: 'card-outRegister',
        meta: {
          title: '卡片详情',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardOutDJ/index.vue`),
      },
      {//数据资产卡片登记 -- 外部登记
        path: '/card-outRegister-new',
        name: 'card-outRegister-new',
        meta: {
          title: '存证登记',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardOutDJ/cardOutDJ.vue`),
      },
      {//数据资产卡片登记 -- 确权登记
        path: '/card-confirm',
        name: 'card-confirm',
        meta: {
          title: '确权登记',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardConfirm/index.vue`),
      },
         {//数据资产卡片登记 -- 卡片登记 2.0
          path: '/card-register-new',
          name: 'card-register-new',
          meta: {
            title: '卡片登记',
            showLeftMenu: true
          },
          component: () => import(`../views/cardRegister/cardRegister/index.vue`),
        },
      {//数据资产卡片登记 -- 确权登记
        path: '/card-confirm-new',
        name: 'card-confirm-new',
        meta: {
          title: '确权登记',
          showLeftMenu: true
        },
        component: () => import(`../views/cardRegister/cardConfirm/cardConfirm.vue`),
      },
      {//评价配置
        path: '/evaluation-configure',
        name: 'evaluation-configure',
        meta: {
          title: '评估配置',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/configure/index.vue`),
      },

      {//规则库
        path: '/rule-library',
        name: 'rule-library',
        meta: {
          title: '规则库',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/rule-library/index.vue`),
      },
      {//配置规则
        path: '/configure-rule',
        name: 'configure-rule',
        meta: {
          title: '配置规则',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/rule-library/comp/configure-rule.vue`),
      },
      //
      {//评分模板库
        path: '/rating-template',
        name: 'rating-template',
        meta: {
          title: '评价项目模板库',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/rating-template/index.vue`),
      },
      {//报告模板库
        path: '/report-template',
        name: 'report-template',
        meta: {
          title: '评分模板库',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/report-template/index.vue`),
      },
      {//数据质量报告
        path: '/data-quality-report',
        name: 'data-quality-report',
        meta: {
          title: '质量报告',
          showLeftMenu: true

        },
        component: () => import(`../views/assetEvaluation/data-quality-report/index.vue`),
      },
      {//质量监控
        path: '/quality-monitor',
        name: 'quality-monitor',
        meta: {
          title: '质量监控',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/quality-monitor/index.vue`),
      },
      {//评估项目
        path: '/evaluation-project',
        name: 'evaluation-project',
        meta: {
          title: '评估项目',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/project/index.vue`),
      },
      {//评估作价
        path: '/evaluation-pricing',
        name: 'evaluation-pricing',
        meta: {
          title: '评估作价',
          showLeftMenu: true

        },
        component: () => import(`../views/assetEvaluation/pricing/index.vue`),
      },
      {//评估报告
        path: '/evaluation-report',
        name: 'evaluation-report',
        meta: {
          title: '评估报告',
          showLeftMenu: true

        },
        component: () => import(`../views/assetEvaluation/pricing/index.vue`),
      },
      {// 数据资产出售
        path: '/sell',
        name: 'sell',
        meta: {
          title: '数据资产出售',
          showLeftMenu: true
        },
        component: () => import(`../views/use-disposal/sell/index.vue`),
      },
      {//数据资产质押
        path: '/pledge',
        name: 'pledge',
        meta: {
          title: '数据资产质押',
          showLeftMenu: true
        },
        component: () => import(`../views/use-disposal/pledge/index.vue`),
      },
      {//数据资产入股
        path: '/investment',
        name: 'investment',
        meta: {
          title: '数据资产入股',
          showLeftMenu: true
        },
        component: () => import(`../views/use-disposal/investment/index.vue`),
      },
      {//数据资产销毁
        path: '/destruction',
        name: 'destruction',
        meta: {
          title: '数据资产销毁',
          showLeftMenu: true
        },
        component: () => import(`../views/use-disposal/destruction/index.vue`),
      },
      {//会计核算 个性化设置
        path: '/personalized-settings',
        name: 'personalized-settings',
        meta: {
          title: '个性化设置',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/personalized-settings/index.vue`),
      },
      {//会计核算 资本化台账
        path: '/capitalization-ledger',
        name: 'capitalization-ledger',
        meta: {
          title: '数据资产成本计算',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/capitalization-ledger/index.vue`),
      },
      {//会计核算 初始计量
        path: '/asset-measurement',
        name: 'asset-measurement',
        meta: {
          title: '数据资产初始计量',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/asset-measurement/index.vue`),
      },
      {//会计核算 收入核算
        path: '/revenue-accounting',
        name: 'revenue-accounting',
        meta: {
          title: '数据资产收入核算',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/revenue-accounting/index.vue`),
      },
        {//会计核算 半年报披露
        path: '/half-year-report-disclosure',
        name: 'half-year-report-disclosure',
        meta: {
          title: '数据资产半年报披露',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/half-year-report-disclosure/index.vue`),
      },
      //
      {//会计核算 计提摊销
        path: '/provision-amortization',
        name: 'provision-amortization',
        meta: {
          title: '无形资产计提摊销',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/provision-amortization/index.vue`),
      },
      {//会计核算 减值核算
        path: '/impairment-accounting',
        name: 'impairment-accounting',
        meta: {
          title: '数据资产减值和跌价',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/impairment-accounting/index.vue`),
      },
      {//会计核算 处置核算
        path: '/disposal-accounting',
        name: 'disposal-accounting',
        meta: {
          title: '数据资产处置核算',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/disposal-accounting/index.vue`),
      },
      {//会计核算 信息披露
        path: '/information-disclosure',
        name: 'information-disclosure',
        meta: {
          title: '数据资产信息披露',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/information-disclosure/index.vue`),
      },
      {//会计核算 月末关账
        path: '/closing-accounts',
        name: 'closing-accounts',
        meta: {
          title: '月末关账',
          showLeftMenu: true
        },
        component: () => import(`../views/accounting/closing-accounts/index.vue`),
      },
      {//数据标准编目
        path: '/data-standard-cataloging',
        name: 'data-standard-cataloging',
        meta: {
          title: '数据标准编目',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/data-standard/cataloging/list.vue`),
      },
      {//数据标准编目
        path: '/data-standard-document',
        name: 'data-standard-document',
        meta: {
          title: '数据标准文档',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/data-standard/document/index.vue`),
      },
      {//数据标准
        path: '/data-standard-field',
        name: 'data-standard-field',
        meta: {
          title: '数据标准字段',
          showLeftMenu: true
        },
        component: () => import(`../views/assetEvaluation/data-standard/field/list.vue`),
      },

    ]
  },
  {
    path: '/meta-main',
    name: 'meta-main',
    component: () => import(`@/views/meta-main.vue`),
      children: [
        {
          path: '/data-source-manage',
          name: 'data-source-manage',
          meta: {
            title: '数据源管理',
            showLeftMenu: true
          },
          component: () => import(`../views/meta-data/data-source-manage/index.vue`),
        },
        {
          path: '/meta-data-collect',
          name: 'meta-data-collect',
          meta: {
            title: '元数据采集',
            showLeftMenu: true
          },
          component: () => import(`../views/meta-data/meta-data-collect/index.vue`),
        },
        {
          path: '/meta-data-manage',
          name: 'meta-data-manage',
          meta: {
            title: '元数据管理',
            showLeftMenu: true
          },
          component: () => import(`../views/meta-data/meta-data-manage/index.vue`),
        },
        {
          path: '/label-manage',
          name: 'label-manage',
          meta: {
            title: '元数据管理',
            showLeftMenu: true
          },
          component: () => import(`../views/meta-data/label-manage/index.vue`),
        },
      ]
  }
]

// console.log(routes);
export default routes;



// WEBPACK FOOTER //
// ./src/router/home.js